<template>
  <div>
    <vx-card title="Информация об обращении" class="mb-8">
      <div class="vx-row">
        <div class="vx-col flex-1">
          <table class="w-3/5">
            <tr>
              <td class="font-semibold">Номер обращения</td>
              <td class="pl-4">
                <span class="text-primary">#{{ service.id }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Дата создания</td>
              <td class="pl-4">
                <span class="text-primary">{{ service.date_created }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Статус</td>
              <td class="pl-4 w-2/5">
                <v-select
                  class="w-15"
                  @input="updateServiceStatus"
                  label="name"
                  :options="statusType"
                  :clearable="false"
                  v-model="service.status"
                >
                  <div slot="no-options">Совпадений не найдено</div>
                </v-select>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Стоимость</td>
              <td class="pl-4 pt-4">
                <vs-input
                  class="w-full mb-4"
                  placeholder="Стоимость"
                  type="number"
                  v-model.number="service.price"
                />
                <vs-button
                  @click="updatePrice"
                  size="small"
                  color="primary"
                  type="filled"
                  >Обновить</vs-button
                >
              </td>
            </tr>
          </table>
        </div>

        <div class="vx-col flex-1">
          <table>
            <tr>
              <td class="font-semibold">Автор заявки</td>
              <td class="pl-4">
                <span v-if="service.user" class="text-primary">{{
                  service.user.full_name
                }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Номер телефона</td>
              <td class="pl-4">
                <a
                  v-if="service.user"
                  :href="`tel:${service.user.phone}`"
                  class="text-primary"
                  >{{ service.user.phone }}</a
                >
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Адрес</td>
              <td class="pl-4">
                <span class="text-primary"
                  >{{ service.user.county_type.name }}, ул.
                  {{ service.address }}</span
                >
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Выбранная дата и время</td>
              <td class="pl-4">
                <span class="text-primary">{{
                  formatDateTime(service.date_recommend)
                }}</span>
              </td>
            </tr>

            <tr>
              <td class="font-semibold">Сервисы</td>
              <td class="pl-4 pt-4">
                <p
                  v-for="(item, index) in service.services"
                  :key="index"
                  class="mb-2"
                >
                  <span class="text-primary">{{ item.name }}</span>
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <template>
        <div class="py-4">
          <vs-button
            @click="popupDeleteComfirm = true"
            class="mr-4"
            color="danger"
          >
            Удалить
          </vs-button>
          <vx-tooltip
            v-if="!service.is_hidden"
            class="inline-block"
            text="Скрыть заявку из общего списка"
          >
            <vs-button @click="changeVisible(true)" color="warning">
              Скрыть заявку
            </vs-button>
          </vx-tooltip>
          <vx-tooltip
            v-else
            class="inline-block"
            text="Вернуть заявку в общий список"
          >
            <vs-button @click="changeVisible(false)" color="warning">
              Показать заявку
            </vs-button>
          </vx-tooltip>
        </div>
      </template>

      <vs-divider position="center"> Сообщения </vs-divider>

      <vs-row>
        <vs-col vs-w="12">
          <template v-if="service.messages && service.messages.length">
            <div id="component-chat-log" class="m-8">
              <div
                v-for="(msg, index) in service.messages"
                class="msg-grp-container"
                :key="index"
              >
                <template v-if="service.messages[index - 1]">
                  <vs-divider
                    v-if="
                      !isSameDay(
                        msg.date_created,
                        service.messages[index - 1].date_created
                      )
                    "
                    class="msg-time"
                  >
                    <span>{{ toDate(msg.date_created) }}</span>
                  </vs-divider>
                  <div
                    class="spacer mt-8"
                    v-if="
                      msg.from_user !== service.messages[index - 1].from_user
                    "
                  ></div>
                </template>

                <div
                  class="group flex items-center flex-wrap"
                  :class="msg.from_user !== 'admin' ? '' : 'flex-row-reverse'"
                >
                  <div
                    class="w-full wrap-message flex items-center"
                    :class="
                      msg.from_user !== 'admin'
                        ? ''
                        : 'flex-row-reverse justify-start'
                    "
                  >
                    <vs-button
                      @click="deleteMessage(msg.id)"
                      color="danger"
                      size="small"
                      type="filled"
                      radius
                      icon="icon-trash-2"
                      icon-pack="feather"
                      class="order-2 hidden group-hover:inline-flex"
                      :class="{
                        'mr-2': msg.from_user === 'admin',
                        'ml-2': msg.from_user !== 'admin',
                      }"
                    ></vs-button>
                    <div
                      class="
                        msg
                        break-words
                        relative
                        shadow-md
                        rounded
                        py-3
                        px-4
                        mb-1
                        mt-1
                        rounded-lg
                        max-w-sm
                        order-1
                      "
                      :class="{
                        'bg-primary-gradient text-white':
                          msg.from_user === 'admin',
                        'border border-solid border-transparent bg-white':
                          !msg.from_user === 'admin',
                      }"
                    >
                      <span>{{ msg.text }}</span>
                    </div>
                  </div>

                  <span
                    v-if="
                      msg.from_user === 'admin' && msg.id == ticket.last_message
                    "
                    class="text-sm"
                    >{{
                      ticket.last_message_status == "read"
                        ? "Прочитано"
                        : "Отправлено"
                    }}</span
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-else> Сообщений нет </template>
          <div
            v-if="!service.is_closed"
            class="chat__input flex p-4 bg-white w-full"
          >
            <vs-input
              class="flex-1"
              placeholder="Введите сообщение"
              v-model="typedMessage"
              @keyup.enter="sendMsg"
            />
            <vs-button
              class="bg-primary-gradient ml-4"
              type="filled"
              @click="sendMsg"
              >Отправить</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </vx-card>

    <vs-popup
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
    >
      <p class="font-semibold mb-5">
        Заявка <span class="text-danger text-lg">#{{ service.id }}</span>
        будет удалена безвозвратно
      </p>
      <vs-button
        @click="deleteRequest"
        color="danger"
        class="mr-5"
        type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { API_URL, statusType, countyType } from "@/.env";

export default {
  data: () => ({
    service: [],
    typedMessage: "",

    statusType: statusType,
    countyType: countyType,
    BASE_URL: API_URL,

    popupDeleteComfirm: false,
  }),
  components: {},
  watch: {
    "$route.params.id": {
      handler: function (id) {
        this.getTicket(id);
      },
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    formatDateTime(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    updateServiceStatus(val) {
      this.$load(async () => {
        let payload = {
          status: val.id,
        };

        try {
          let res = (
            await this.$api.services.updateStatusRequest(
              this.service.id,
              payload
            )
          ).data;
          this.notification(
            "Успешно",
            `Статус заявки изменен на ${val.name}`,
            "success"
          );
        } catch (error) {
          this.notification(
            "Ошибка",
            `Статус заявки изменить не удалось`,
            "warning"
          );
        }
      });
    },
    sendMsg() {
      if (!this.typedMessage) return;

      let payload = {
        from_user: "admin",
        text: this.typedMessage,
        chat: this.service.chat,
      };

      this.$load(async () => {
        let res = (await this.$api.services.sendMessage(payload)).data;
        this.ticket.last_message = res.id;
        this.ticket.last_message_status = "sent";

        this.service.messages.push(res);
      });

      this.typedMessage = "";
    },
    isSameDay(time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to));
      const date_time_from = new Date(Date.parse(time_from));
      return (
        date_time_to.getFullYear() === date_time_from.getFullYear() &&
        date_time_to.getMonth() === date_time_from.getMonth() &&
        date_time_to.getDate() === date_time_from.getDate()
      );
    },
    toDate(time) {
      const locale = "ru-ru";
      const date_obj = new Date(Date.parse(time));
      const monthName = date_obj.toLocaleString(locale, {
        month: "short",
      });
      const yearFull = date_obj.toLocaleString(locale, {
        year: "numeric",
      });
      return `${date_obj.getDate()} ${monthName} ${yearFull}`;
    },
    getService(id) {
      this.$load(async () => {
        let res = (await this.$api.services.getRequest(id)).data;

        res.date_created = this.formatDate(res.date_created);

        res.user.county_type = countyType.find(
          (x) => x.id == res.user.county_type
        );

        res.status = this.statusType.find((x) => x.id == res.status);

        this.service = res;
      });
    },
    updatePrice() {
      this.$load(async () => {
        let payload = {
          price: this.service.price,
        };

        try {
          let res = (
            await this.$api.services.updatePriceRequest(
              this.service.id,
              payload
            )
          ).data;
          this.notification("Успешно", `Цена обновлена`, "success");
        } catch (error) {
          this.notification("Ошибка", `Цену изменить не удалось`, "danger");
        }
      });
    },
    deleteMessage(idMessage) {
      this.$load(async () => {
        try {
          let res = (await this.$api.services.deleteMessage(idMessage)).data;

          let item = this.service.messages.find((x) => x.id == idMessage),
            index = this.service.messages.indexOf(item);

          if (index !== -1) {
            this.service.messages.splice(index, 1);
          }

          this.notification("Успешно", `Сообщение удалено`, "success");
        } catch (error) {
          this.notification("Ошибка", `Не удалось удалить сообщение`, "danger");
        }
      });
    },
    deleteRequest() {
      this.$load(async () => {
        await this.$api.services
          .deleteRequest(this.service.id)
          .then((response) => {
            if (response.status == 200) {
              this.popupDeleteComfirm = false;
              this.notification("Успешно", `Заявка удалена`, "success");
            }
          })
          .catch((error) => {
            this.notification("Ошибка", `Не удалось удалить заявку`, "danger");
          });
        this.$router.push({ name: "requests" });
      });
    },
    changeVisible(type) {
      this.$load(async () => {
        let payload = {
          is_hidden: type,
        };

        await this.$api.services
          .updateVisibleRequest(this.service.id, payload)
          .then((response) => {
            this.service.is_hidden = type;
            if (type) this.notification("Успешно", `Заявка скрыта`, "success");
            else
              this.notification(
                "Успешно",
                `Заявка возвращена в общий список`,
                "success"
              );
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              `Не удалось изменить видимость заявки`,
              "danger"
            );
          });
      });
    },
  },
  created() {},
  mounted() {
    this.getService(this.$route.params.id);
  },
};
</script>